import { render } from "./TopBar.vue?vue&type=template&id=7f6c28c2&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=7f6c28c2&lang=css"
import "./TopBar.vue?vue&type=style&index=1&id=7f6c28c2&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\HolyHeart\\presi\\studentapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f6c28c2"]])

export default __exports__